export default __webpack_public_path__ + "static/media/success2.da758ec4.wav";